<template>
  <div>
    <CCardBody>
      <div class="text-right btngroup">
        <CButton v-if="$can('create-role')" class="addBtn" @click="$bvModal.show('rolesModal')">
          Create
        </CButton>
      </div>
      <search v-model="search" float='right' :clickHandler="searchRole" placeholder="Type to search"/>
      <b-table :items="roles" :fields="headers" hover sorter show-empty empty-text="No data exists">
        <template #empty="scope">
          <h5>{{ scope.emptyText }}</h5>
        </template>
        <template #cell(actions)="item">
          <delete v-if="$can('delete-role')" class="delete_role ml-2" @click="deleteRole(item.item.id)" fillColor="#E30000"
                  :id="item.item.id"/>
          <Pencil class="edit_role" v-if="$can('edit-role')" @click="editRole(item)" fillColor="#009FE3"
                  :id="item.item.id"/>
          <router-link v-if="$can('update-permissions')"
                       :to="{ name: 'assignpermissions', params: { id: item.item.id }}">
            <Pencil class="edit_role_permission" fillColor="#009FE3" :id="item.id"/>
          </router-link>
        </template>
      </b-table>
      <b-pagination v-model="pagination.currentPage" :total-rows="pagination.rows" :per-page="pagination.perPage" aria-controls="itemList"
          align="center" @change="handlePagination" v-if="pagination.total > 0" :key="pagination.currentPage">
      </b-pagination>
      <b-modal id="rolesModal" size="md" no-close-on-backdrop hide-footer @hidden="role_obj = getRoleObject()">
        <template #modal-title>
          <span>{{role_obj.id ? 'Update' : 'Create'}} Role</span>
        </template>
        <CRow>
          <CCol class="col-md-12">
            <CInput type="text" name="label" v-model="role_obj.label" v-validate="'required|alpha_spaces'"
                    placeholder="Enter role label">
            </CInput>
            <div v-for="error in errors.collect('label')" :key="error" class="error_msg">
              {{ error }}
            </div>

            <CInput type="text" class="mt-3 w-100 float-right" name="name" v-model="role_obj.name" v-validate="'required|alpha_spaces'"
                    placeholder="Enter role name">
            </CInput>
            <div v-for="error in errors.collect('name')" :key="error" class="error_msg">
              {{ error }}
            </div>

            <b-form-select class="mt-3" name="app_type" v-validate="{required: true}" v-model="role_obj.app_type"
                           :options="appTypeOptions">
            </b-form-select>
            <div v-if="errors && errors.first('app_type')" class="error_msg">
              Type field is required
            </div>

            <CButton color="success" class="mt-5 w-100 float-right" @click="updateCreateRole">
              {{role_obj.id ? 'Update' : 'Save'}}
            </CButton>
          </CCol>
        </CRow>
      </b-modal>
    </CCardBody>
  </div>
</template>
<script>
import Pencil from 'vue-material-design-icons/GreasePencil.vue';
import Delete from 'vue-material-design-icons/Delete.vue';
import myMixins from '@/mixins/myMixins';
import { setPageModal, getLastPage } from "@/helpers/Helpers";
import {http} from "@/config/httpCommon"

export default {
  name: 'roles',
  mixins: [myMixins],
  components: {
    Delete,
    Pencil
  },
  data() {
    return {
      isUpdating: false,
      roleModal: false,
      role_obj: {},
      label: '',
      app_type: '',
      id: '',
      headers: [
        {key: 'label', label: 'Label', sortable: true,},
        {key: 'app_type', label: 'Type',},
        {key: 'actions', label: 'Actions',},
      ],
      roles: [],
      modes: [
        {shape: 'pill'},
      ],
      colors: ['primary'],
      appTypeOptions: [
        {text: 'Please select a type', value: ''},
        {text: 'Admin', value: 'admin'},
        {text: 'Frontend', value: 'customizer'}
      ],
      pagination: {
        rows: null,
        currentPage: null,
        perPage: null,
        total: 0
      },
      search: ''
    }
  },
  async created() {
    this.preservePaginationIgnoreSearch('page', 'search', this.$route.name, this.getRoles)
    this.role_obj = this.getRoleObject()
    await this.getRoles();
  },
  methods: {
    getRoleObject(update_props) {
      return {...{id: null, name: null, app_type: '', role:null}, ...update_props}
    },
    async getRoles(query_params = '') {
      if(query_params) {
        query_params += '&paginate=true'
      } else {
        query_params = '?paginate=true'
      }
      http.get(`role` + query_params).then((successResponse) => {
        const response_data = successResponse.data
        if (response_data.success) {
          this.roles = response_data.result.roles.data
          this.makePagination(response_data.result.roles)
        } else {
          this.showServerErrors(successResponse);
        }
      }).catch((e) => {
        this.handleResponseErrors(e)
      });
    },
    makePagination(data) {
      this.pagination.currentPage = data.current_page;
      this.pagination.rows = data.total;
      this.pagination.perPage = data.per_page;
      this.pagination.total = data.total;
    },
    searchRole(search) {
      let params = ''
      if (search) {
        params = '?search=' + search;
      }
      setPageModal(1,this.$route.name,this.search);
      this.getRoles(params);
    },
    showModal(type) {
      if (type == 'create') {
        this.label = '';
        this.app_type = '';
        this.isUpdating = false;
        this.id = '';
      }
      this.$bvModal.show("rolesModal");
    },
    async updateCreateRole() {
      let valid = await this.$validator.validate();
      if (valid) {
        let action = 'post'
        let url = 'role'
        if(this.role_obj.id) {
          action = 'put'
          url = `role/${this.role_obj.id}`
        }
        http[action](url, this.role_obj).then(successResponse => {
          let response_data = successResponse.data
          if(response_data.success) {
            if(this.role_obj.id) {
              this.preservePagination( 'page', 'search', this.$route.name, this.getRoles)
            } else {
              this.nextPageOnCreation('page', 'search', this.roles.length, this.pagination.perPage, this.pagination.currentPage, getLastPage(this.pagination.perPage, this.pagination.total), this.$route.name, this.getRoles);
            }
            this.$bvModal.hide("rolesModal");
            this.showToast(response_data.message, 'SUCCESS')
          } else {
            this.showServerErrors(successResponse);
          }
        }).catch(errorResponse => {
          this.handleResponseErrors(errorResponse);
        })
      }
    },
    async deleteRole(role_id) {
      http.delete(`role/${role_id}`).then(successResponse => {
        let response_data = successResponse.data
        if(response_data.success) {
          // this.getRoles()
          this.previousPageOnDeletion('page','search',this.roles.length - 1,this.$route.name,this.getRoles);
        } else {
          this.showServerErrors(successResponse);
        }
      }).catch(errorResponse => {
        this.handleResponseErrors(errorResponse);
      });
    },
    editRole(item_data) {
      let role = item_data.item;
      this.role_obj = {
        id: role.id, name: role.name, app_type: role.app_type
      }
      this.$bvModal.show('rolesModal')
    },
    async handlePagination(page = '') {
      let params = '?page=' + page;
      if (this.search) {
        params += '&search=' + this.search
      }
      setPageModal(page,this.$route.name,this.search);
      this.getRoles(params);
    }
  },

}
</script>
<style type="scss">
.delete_role {
  cursor: pointer;
}

.edit_role {
  cursor: pointer;
}
</style>